import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import createLogger from 'src/utils/logger';
import { auth, user, modalWindows } from 'src/actions';
import LeftBar from './LeftBar';
import Projects from './Projects';
import Tokens from './Tokens';
import UserHackatons from './UserHackatons';
import { Mixpanel } from '../Mixpanel';

import './Account.scss';

const CONTENT_STATES = {
  hackathons: 'hackathons',
  tokens: 'tokens',
  projects: 'projects',
};

class Account extends Component {
  constructor() {
    super();
    this.logger = createLogger('Account');
    this.state = {
      selectedMenuTab: 'tokens',
      fetchingData: true,
    }
  }

  componentDidMount() {
    Mixpanel.track('Page account')
    this.checkIfUserAutherized();
    this.onRoutingUpdate();
  }

  checkIfUserAutherized = () => {
    const registerToken = this.props.location.state && this.props.location.state.regKey; // eslint-disable-line react/prop-types
    if (registerToken) {
      this.props.loginWithToken(registerToken)
        .then(this.getUserProfileWithProjects)
        .catch(this.onAuthorizationError)
    } else {
      this.getUserProfileWithProjects();
    }
  }

  getUserProfileWithProjects = () => {
    return Promise.all([this.props.getUserProfile()/*, this.props.getUserProjects()*/])
      .then(this.onAuthorized)
      .catch(this.onAuthorizationError);
  }
  
  onAuthorized = () => {
    this.setState({
      fetchingData: false,
    })
  }

  onAuthorizationError = (err) => {
    this.logger.debug('onAuthorizationError', err);
    this.logger.info('onAuthorizationError() redirecting to "/"');
    this.props.history.push('/');
  }

  onRoutingUpdate = () => {
    this.logger.debug('onRoutingUpdate()', this.props.history);
    let tabName;
    try {
      tabName = this.props.history.location.state.tabName; // eslint-disable-line react/prop-types
    } catch(e) {}
    if (tabName && !CONTENT_STATES[tabName]) {
      this.logger.error('componentWillMount() tabName not supported:', tabName);
    }
    this.setState({
      selectedMenuTab: tabName || CONTENT_STATES.tokens,
    }, () => window.scrollTo(0, 0));
  }

  updateSelectedMenuTab = (selectedMenuTab) => {
    this.logger.info('updateSelectedMenuTab()', selectedMenuTab);
    this.setState({ selectedMenuTab });
  }

  getChildComponent = () => {
    switch (this.state.selectedMenuTab) {
      case CONTENT_STATES.tokens:
        return <Tokens />
      case CONTENT_STATES.projects:
        return <Projects projects={this.props.user.projects} />;
      default:
        return <UserHackatons />;
    }
  }

  render() {
    const { selectedMenuTab, fetchingData } = this.state;
    if (fetchingData) {
      return (
        <div className='account skeleton'>
          <div className="dual-loader"></div>
        </div>
      )
    }
    const { user } = this.props;
    return (
      <div className='account'>
        <div className="account__container">
          <div className='account__title'>Привет, {user.username}</div>
          <div className="account__content">
            <LeftBar username={user.username} openResetPasswordModal={this.props.openResetPwdModal}/>
            <div className="account__main">
              <div className="account__main-header">
                <div className="account__main-header-wrapper">
                </div>
                <ul className='account__header__list'>
                  <li className={selectedMenuTab === 'tokens' ? 'account__header__item active' : 'account__header__item'}
                    onClick={() => this.updateSelectedMenuTab('tokens')}>
                    Токены
                    <sup className='after-number'>{user.wallet.tokens}</sup>
                  </li>
                  {/* <li className={selectedMenuTab === 'projects' ? 'account__header__item active' : 'account__header__item'}
                    onClick={() => this.updateSelectedMenuTab('projects')}>
                    Проекты
                    <sup className='after-number'>{user.projects.length}</sup>
                  </li> */}
                  <li className={selectedMenuTab === 'hackathons' ? 'account__header__item active' : 'account__header__item'}
                    onClick={() => this.updateSelectedMenuTab('hackathons')}>
                    Мои хакатоны
                    <sup className='after-number'>{user.events.length}</sup>
                  </li>
                </ul>
              </div>
              <div className='component_wrapper'>
                { this.getChildComponent() }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Account.propTypes = {
  user: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  getUserProfile: PropTypes.func.isRequired,
  getUserProjects: PropTypes.func.isRequired,
  openResetPwdModal: PropTypes.func.isRequired,
  loginWithToken: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    loginWithToken: auth.loginWithToken,
    getUserProfile: user.getUserProfile,
    getUserProjects: user.getUserProjects,
    openResetPwdModal: modalWindows.openResetPwdModal,
  })(Account));


// WEBPACK FOOTER //
// ./src/components/Account/index.js